  export let currencyType = {
  "PKR": {
   // replace with your actual PKR image
    code: "Rs.",
    name: "Pakistani Rupee",
  },
  "USD": {
      // replace with your actual USD image
    code: "$",
    name: "US Dollar"
  },
  "AED": {
       // replace with your actual AED image
    code: "AED",
    name: "UAE Dirham"
  }
};
  export let currencyType2 = {
  "Pakistan": {
   // replace with your actual PKR image
    code: "Rs.",
    name: "Pakistani Rupee",
  },
  "USA": {
      // replace with your actual USD image
    code: "$",
    name: "US Dollar"
  },
  "United Arab Emirates": {
       // replace with your actual AED image
    code: "AED",
    name: "UAE Dirham"
  }
};